import axiosInstance from "./AxiosInstance";

const getAdminId = () => {
  try {
    const userDetails = localStorage.getItem("userDetails") ? JSON.parse(localStorage.getItem("userDetails")) : null;
    return userDetails?.admin_id || 0;
  } catch (error) {
    console.error("Error getting admin_id: ", error);
    return 0;
  }
};

export function getAnupanList(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  const admin_id = getAdminId();
  return axiosInstance.post("anupana/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
    admin_id,
  });
}

export function createAnupan(anupanData) {
  const admin_id = getAdminId();
  return axiosInstance.post("anupana/add", {
    ...anupanData,
    admin_id,
  });
}

export function updateAnupan(anupanData) {
  const admin_id = getAdminId();
  return axiosInstance.post("anupana/edit", {
    ...anupanData,
    admin_id,
  });
}

export function deleteAnupan(anupanId) {
  const admin_id = getAdminId();
  return axiosInstance.post("anupana/delete", {
    anupana_id: anupanId,
    admin_id,
  });
}

export function formatAnupans(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((item) => ({
      id: item.anupana_id,
      anupana_text: item.anupana_text,
      anupana_status: item.anupana_status,
    }));
  }

  return [];
}
